<template>
    <div class="aiBox">
        <iframe
        v-if="login_status == 1"
            ref="iframe"
            :src="htmlSrc"
            sandbox="allow-forms allow-modals allow-popups  allow-scripts allow-top-navigation allow-same-origin allow-downloads"
            frameborder="0"
        />
        <!-- <div class="left" v-if="login_status == 1">
            <div class="logoBig">
                LOGO
            </div>
            <div class="newMessage">
                <img src="../../assets/img/5.0/ai (6).png" alt="">
            </div>
            <div class="taps">
                <div class="tap" @click="tapValue = 1" :class="{choseTap:tapValue == 1}" style="margin-right:30px">推荐</div>
                <div class="tap" @click="tapValue = 2" :class="{choseTap:tapValue == 2}">历史对话</div>
            </div>
            <div class="msgLists" v-if="tapValue == 1">
                <div class="msgBox" @click="choseBox(item.id)" :class="{chosedBox:aiType_id == item.id}" v-for="item in aiList" :key="item.id" >
                    <img src="../../assets/img/5.0/ai (12).png" alt="">
                    <p>{{item.title}}</p>
                </div>
            </div>
        </div> -->
        <div class="right1" v-if="login_status != 1">
            <div class="content">
                <h1>欢迎您使用瑞鑫点教AI教研</h1>
                <div class="typeBox">
                    <h4>您可以<span>点击卡片</span>使用不同的智能场景</h4>
                    <div class="typeList">
                        <div class="card" v-for="item in aiList" :key="item.id">
                            <img :src="item.file_url" alt="">
                        </div>
                    </div>
                </div>
                <div class="loginTips" @click="goLogin">
                    <div class="tips">
                        <img src="../../assets/img/5.0/ai (10).png" alt="">
                        <p>立即登录，体验更多功能~</p>
                    </div>
                </div>
                <div class="tishi">*内容由AI大模型生成，请仔细甄别</div>
            </div>
        </div>
        <div class="other" @click="goOther">
            <img src="../../assets/img/5.0/ai (5).png" alt="">
        </div>
    </div>
  <!-- <div id="container" v-if="false">
    
    <div class="right" v-if="login_status == 1">
        <router-view :querys="querys"/>
    </div>
    
  </div> -->
</template>

<script>
import { islogin,list_aitype,list_aichat} from "../../api/http";
export default {
    data(){
        return{
            login_status:'',
            tapValue:1,
            aiList:[],
            aiType_id:5,
            querys:{
               url:'',
               aiType_id:5, 
               type_id:1,
            },//传过去的参数
        }
    },
    computed: {
        htmlSrc() {
        // 根据查询参数生成 iframe 的 src 属性
            return 'https://jypt.idianjiao.com/ai/#/';
            // return 'https://jyptwebtest.idianjiao.com/ai/#/';
        }
    },
    created(){
        this.getAiList();
        islogin({md5key: localStorage.getItem("md5key"),}).then(res=>{
            this.login_status = res.retRes.login_status;
            if(res.retRes.login_status == 1){
                this.getLogCvs()
            }
        })
        // this.querys.url = this.$globalUrl + '/ai/#/?aitype_id=' + this.querys.aiType_id + '&type=' + this.querys.type_id;
        
    },
    mounted(){},
    methods:{
        goOther(){
            this.$router.push({
                path: "/AIjiaoyan/other",
            })
        },
        //获取AI应用列表 同 推荐栏
        getAiList(){
            list_aitype({md5key: localStorage.getItem("md5key"),}).then(res=>{
                this.aiList = res.retRes
            })
        },
        //获取历史对话
        getLogCvs(){
            list_aichat({
                md5key: localStorage.getItem("md5key"),
                page:1,
                page_size:10,
            })
        },
        //前往登录页
        goLogin(){
            this.$router.push({
                name:'Login',
            })
        },
        choseBox(e){
            console.log(e)
            this.aiType_id = e
            this.querys.aiType_id = e
            this.querys.url = this.$globalUrl + '/ai/#/?aitype_id=' + this.querys.aiType_id + '&type=' + this.querys.type_id;
        },
    },
}
</script>

<style lang="less" scoped>
.aiBox{
    width: 100%;
    height: 100vh;
    iframe{
        width: 100%;
        height: 100%;
    }
    .other{
        position: absolute;
        top: 95px;
        right: 60px;
        cursor: pointer;
    }
}
    // #container{
    //     display: flex;
    //     .left{
    //         overflow: hidden;
    //         // display: flex;
    //         // flex-direction: column;
    //         // align-items: center;
    //         width: 240px;
    //         height: 100vh;
    //         background: #FAFCFF;
    //         .logoBig{
    //             margin-top: 40px;
    //             margin-left: 20px;
    //             width: 200px;
    //             height: 48px;
    //             background: #E6ECFA;
    //             text-align: center;
    //             line-height: 48px;
    //             font-size: 24px;
    //             color: #1E60EB;
    //             font-weight: bold;
    //         }
    //         .newMessage{
    //             display: flex;
    //             align-items: center;
    //             justify-content: center;
    //             margin-left: 20px;
    //             margin-top: 40px;
    //             margin-bottom: 30px;
    //             font-weight: bold;
    //             width: 140px;
    //             height: 48px;
    //             // background: #E6ECFA;
    //             border-radius: 10px;
    //             // font-size: 16px;
    //             // color: #1E60EB;
    //             cursor: pointer;
    //             img{
    //                 width: 100%;
    //             }
    //         }
    //         .taps{
    //             display: flex;
    //             align-items: center;
    //             margin-left: 20px;
    //             margin-bottom: 20px;
    //             font-size: 16px;
    //             font-weight: bold;
    //             .tap{
    //                 font-size: 16px;
    //                 font-weight: bold;
    //                 color: #333;
    //                 cursor: pointer;
    //             }
    //             .choseTap{
    //                 color: #1E60EB;
    //             }
    //         }
    //         .msgLists{
    //             display: flex;
    //             flex-direction: column;
    //             align-items: center;
    //             .msgBox{
    //                 display: flex;
    //                 align-items: center;
    //                 margin-bottom: 10px;
    //                 width: 200px;
    //                 height: 42px;
    //                 background: #E6ECFA;
    //                 border-radius: 6px;
    //                 cursor: pointer;
    //                 img{
    //                     margin-left: 10px;
    //                     width: 10px;
    //                 }
    //                 p{
    //                     margin-left: 4px;
    //                     font-size: 14px;
    //                     color: #333;
    //                 }
    //             }
    //             .msgBox:active{
    //                 opacity: .8;
    //             }
    //             .chosedBox{
    //                 background: #1E60EB;
    //                 p{
    //                     color: #FFF;
    //                 }
    //             }
    //         }
    //     }
    //     .right{
    //         flex: 1;
    //         max-width: 1600px;
    //     }
        .right1{
            flex: 1;
            display: flex;
            justify-content: center;
            .content{
                margin-bottom: 40px;
                width: 1200px;
            }
            h1{
                margin: 60px auto;
                font-size: 32px;
                color: #1A1A1A;
                text-align: center;
            }
            .typeBox{
                width: 100%;
                background: #FFFFFF;
                border-radius: 10px;
                overflow: hidden;
                h4{
                    margin-left: 60px;
                    margin-top: 60px;
                    margin-bottom: 40px;
                    color: #333333;
                    font-size: 16px;
                    span{
                        color: #1E60EB;
                    }
                }
                .typeList{
                    display: flex;
                    align-items: center;
                    margin-left: 60px;
                    margin-bottom: 40px;
                    // justify-content: center;
                    .card{
                        margin-right: 40px;
                        img{
                            width: 240px;
                            border-radius: 10px;
                        }
                    }
                }
            }
            .loginTips{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 20px;
                width: 1200px;
                height: 100px;
                background: #FFFFFF;
                border-radius: 10px;
                cursor: pointer;
                .tips{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 720px;
                    height: 48px;
                    background: #F0F4FA;
                    border-radius: 24px;
                    img{
                        width: 17px;
                    }
                    p{
                        font-size: 14px;
                        color: #1E60EB;
                    }
                }
            }
            .tishi{
                margin-top: 20px;
                text-align: center;
                font-size: 14px;
                color: #999999;
            }
        }
    // }
</style>